import * as _ from "lodash";
export class RejectionModalComponent implements ng.IComponentOptions {
  public controller: any = RejectionModalController;
  public bindings: any = {
    modalInstance: "<",
    resolve: "<"
  }
  public template: string =
  `
  <div class="modal-header">
    <button type="button" class="close" ng-click="$ctrl.cancel()" aria-label="Close"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="userModal">Rejection Reason</h4>
  </div>
  <div class="modal-body">
    <form name="rejectForm" class="form-horizontal">
      <div class="form-group">
        <label for="reason" class="col-sm-3 control-label">Reason</label>
        <div class="col-sm-9">
        <ui-select ng-model="$ctrl.form.reason" required name="reason">
          <ui-select-match placeholder="Select Rejection Reason">
            <span ng-bind="$select.selected.name"></span>
          </ui-select-match>
          <ui-select-choices repeat="item._id as item in ($ctrl.reasons | filter: $select.search)">
            <div><span ng-bind="item.name | highlight: $select.search"></span></div>
            <small ng-bind="item.description | highlight: $select.search"></small>
          </ui-select-choices>
        </ui-select>
        <input type="text" class="form-control margin-top" ng-model="$ctrl.newReason.name" ng-show="$ctrl.form.reason === 'new'" placeholder="New Reason"/>
        <textarea class="form-control margin-top" ng-model="$ctrl.newReason.description" ng-show="$ctrl.form.reason === 'new'" placeholder="New Reason Description"></textarea>
        </div>
      </div>
      <div class="form-group">
        <label for="notes" class="col-sm-3 control-label">Notes</label>
        <div class="col-sm-9">
          <textarea class="form-control" placeholder="Notes" ng-model="$ctrl.form.notes" ></textarea>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()">Close</button>
    <button type="button" class="btn btn-primary" ng-click="rejectForm.$valid && $ctrl.accept()">Save changes</button>
  </div>`;
}

export class RejectionModalController {
  public static $inject: Array<string> = ['$http'];
  public modalInstance: ng.ui.bootstrap.IModalServiceInstance;
  public resolve: any;
  public form: any;
  public newReason: any;
  public reasons: Array<any>;
  public error: boolean;
  constructor(private $http: ng.IHttpService) {
    this.reasons = [{name: "New", _id: "new"}];
    $http.get(`${BASE}/api/rejection`).then((d:any) => {
      this.reasons = _.concat(this.reasons, d.data);
      if (this.reasons.length === 1) {
        this.form = {reason: "new", notes: ""};
      }
    })
  }
  public cancel() {
    this.modalInstance.dismiss('canceled');
  }
  public accept() {
    if (this.form.reason === 'new') {
      if (this.newReason.name === "") {
        return;
      }
      else {
        this.$http.post(`${BASE}/api/rejection`,this.newReason)
        .then((rejection:any) => {
          this.form.reason = rejection.data._id;
          this.modalInstance.close(this.form);
        })
        .catch(err => {
          this.error = true;
        })
      }
    }
    else
      this.modalInstance.close(this.form);
  }
}
